var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled, { keyframes } from "styled-components";
import { colors } from "@wrstudios/theme";
var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var sizes = {
  xxs: {
    diameter: 2.4,
    fontSize: 1.1
  },
  xs: {
    diameter: 3.2,
    fontSize: 1.3
  },
  sm: {
    diameter: 4.8,
    fontSize: 2
  },
  md: {
    diameter: 6,
    fontSize: 2.4
  },
  lg: {
    diameter: 9,
    fontSize: 3
  },
  xl: {
    diameter: 12,
    fontSize: 3.8
  },
  xxl: {
    diameter: 15,
    fontSize: 5
  }
};
export var Container = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: ", "rem;\n  height: ", "rem;\n  font-size: ", "rem;\n  line-height: 0;\n  background-color: ", ";\n  background-position: center center;\n  background-image: ", ";\n  background-size: cover;\n  border-radius: 50%;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: ", "rem;\n  height: ", "rem;\n  font-size: ", "rem;\n  line-height: 0;\n  background-color: ", ";\n  background-position: center center;\n  background-image: ", ";\n  background-size: cover;\n  border-radius: 50%;\n  color: ", ";\n"])), function (_a) {
  var size = _a.size;
  return sizes[size].diameter;
}, function (_a) {
  var size = _a.size;
  return sizes[size].diameter;
}, function (_a) {
  var size = _a.size;
  return sizes[size].fontSize;
}, function (_a) {
  var avatarUrl = _a.avatarUrl,
      initialsColor = _a.initialsColor;
  return avatarUrl ? "transparent" : initialsColor;
}, function (_a) {
  var avatarUrl = _a.avatarUrl;
  return avatarUrl ? "url('" + avatarUrl + "')" : "none";
}, colors.white);
export var Loading = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  svg {\n    width: 8rem;\n    height: 8rem;\n    fill: ", ";\n    animation: ", " 0.75s linear infinite;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  svg {\n    width: 8rem;\n    height: 8rem;\n    fill: ", ";\n    animation: ", " 0.75s linear infinite;\n  }\n"])), colors.white, spin);
var templateObject_1, templateObject_2, templateObject_3;